// SPDX-FileCopyrightText: Copyright 2026 Dash0 Inc.

import { ExtendedIntegrationMetadata } from "@/hub/types";
import { localeCompareIgnoreCase } from "@/lib/utils/string";

export function compareIntegrationsWithinCategory(
  a: ExtendedIntegrationMetadata,
  b: ExtendedIntegrationMetadata,
): number {
  const aIndex = a.indexEntry.categoryIndex;
  const bIndex = b.indexEntry.categoryIndex;

  if (aIndex != null && bIndex != null) {
    return aIndex - bIndex;
  }
  if (aIndex != null) {
    return -1;
  }
  if (bIndex != null) {
    return 1;
  }

  if (a.recommended && !b.recommended) {
    return -1;
  }
  if (b.recommended && !a.recommended) {
    return 1;
  }
  return localeCompareIgnoreCase(a.label, b.label);
}
